import { z } from 'zod'
import { createValidator } from '@mc/form-utils'
import i18nInstance from './i18n/i18nInstance'

const tf = i18nInstance.getFixedT(null, '@mc/certificates')

// Reusable schemas
export const emailSchema = z
  .string({
    required_error: tf(
      'marketingPages.certificate.updatesSignup.emailRequired',
    ),
  })
  .min(1, tf('marketingPages.certificate.updatesSignup.emailRequired'))
  .email(tf('invalidEmail'))

export const gdprOptInSchema = z.literal(true, {
  errorMap: () => ({
    message: tf('marketingPages.certificate.updatesSignup.gdprRequired'),
  }),
})

// Combined schema
export const emailWithGdprSchema = z.object({
  email: emailSchema,
  gdprOptIn: gdprOptInSchema,
})

// Validator
export const validateEmailWithGdpr = createValidator(emailWithGdprSchema)

export const withoutFieldErrors = <T extends object>(meta: T) => ({
  ...meta,
  error: undefined,
  submitError: undefined,
  invalid: false,
})
